import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Utilisateur } from 'app/models/Utilisateur';
import { ArticleService } from 'app/shared/article.service';
import { UtilisateurService } from 'app/shared/utilisateur.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, combineLatest, Subject, takeUntil } from 'rxjs';
import { Location } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Article } from 'app/models/Article';
import { ThemeArticle } from 'app/models/ThemeArticle';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { LoginService } from 'app/login.service';
import { MarketData } from 'app/models/MarketData';
import { PopupLoginComponent } from 'app/modules/popup-login/popup-login.component';
import { DataService } from 'app/shared/data.service';
import { PopupWatchlistComponent } from '../../popup-watchlist/popup-watchlist.component';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { LinkService } from 'app/shared/Link.service';
import { DialogModule } from '@angular/cdk/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from 'app/shared/shared.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ConvertToSlugPipe } from 'app/shared/convert-to-slug.pipe';
import { MetaService } from 'app/shared/meta.service';

@Component({
  selector: 'app-liste-article',
  templateUrl: './liste-article.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    DialogModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTooltipModule,
    SharedModule,
    MatPaginatorModule,
    MatTableModule,
    RouterModule,
    ConvertToSlugPipe,
  ],
})
export class ListeArticleComponent implements OnInit, OnDestroy {
  cloud_front = environment.cloud_front_host;
  watchlist: boolean = false;
  populaires: boolean = true;
  displayedColumns: string[] = ['Trouver un actif', 'Watchlist'];
  displayedColumns1: string[] = ['Trouver un actif', 'Watchlist'];
  public dataSource1 = new MatTableDataSource<MarketData>();
  public dataSource = new MatTableDataSource<MarketData>();
  user: Utilisateur;
  actifs: MarketData[] = [];
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  serveur_name = environment.serveur_name;
  host_name = environment.host_name;
  listeArticles: Article[] = [];

  nbArticle: number;
  auteur = {};
  id: string;
  ThemeArticle = ThemeArticle;
  enumKeys = [];
  filters: {
    articleTheme$: BehaviorSubject<string>;
  } = {
    articleTheme$: new BehaviorSubject('all'),
  };
  articles: Article[];
  filteredArticles: Article[] = [];
  totalPages: number = 0;
  currentPage: number = 0;
  pageSize: number = 9;
  loadingArticles: boolean = true; // Add this variable to track loading state

  constructor(
    private articleService: ArticleService,
    private utilisateurService: UtilisateurService,
    public location: Location,
    private _changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private dataService: DataService,
    public dialog: MatDialog,
    private loginService: LoginService,
    private seoService: LinkService,private metaService: MetaService
  ) {
    this.enumKeys = Object.keys(this.ThemeArticle);
  }

  ngOnInit() {
    this.recupererWatchlist();
    this.recupererPopulaires();
    this.chargerArticle();
    // Filter arycile
    combineLatest([this.filters.articleTheme$]).subscribe(([articleTheme]) => {
      // Reset the filtered courses
      this.filteredArticles = this.listeArticles;

      // Filter by category
      if (articleTheme !== 'all') {
        this.filteredArticles = this.filteredArticles.filter(
          (article) => article.themeArticle === articleTheme,
        );
      }
    });
    this.metaService.updateMetaTags({
      title: 'Actualités financières et boursières en temps réel',
      description: "Actualités financières et boursières en temps réel. Analyses de marché, indices, actions, devises et matières premières. Suivez l'évolution de l'économie tunisienne et internationale",
      canonicalLink: environment.apiUrl+'/actualites/articles',
      keywords: 'Bourse de Tunis, graphique technique, analyse technique, bvmt, conseil en bourse, portefeuille boursier, finance, économie, action, indice, devise, Tunisie, résumé de marché bourse de tunis, investissement',
      ogTitle: 'Actualités financières et boursières en temps réel',
      ogUrl: environment.apiUrl+'/actualites/articles',
      ogDescription: "Actualités financières et boursières en temps réel. Analyses de marché, indices, actions, devises et matières premières. Suivez l'évolution de l'économie tunisienne et internationale",
      twitterTitle: 'Actualités financières et boursières en temps réel',
      twitterDescription: "Actualités financières et boursières en temps réel. Analyses de marché, indices, actions, devises et matières premières. Suivez l'évolution de l'économie tunisienne et internationale",

    });

  }

  createLinkForCanonicalURL() {
    this.seoService.createLinkForCanonicalURL();
  }

  truncateChar(text: string): string {
    let charlimit = 50;
    if (!text || text.length <= charlimit) {
      return text;
    }

    let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
    let shortened = without_html.substring(0, charlimit) + '...';
    return shortened;
  }

  chargerArticle(page: number = 0, size: number = 10) {
    this.loadingArticles = true; // Set loading state to true before making the API call
    this.articleService
      .getArticlesPaginate(this.currentPage, this.pageSize)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (response) => {
          this.listeArticles = response.content;
          this.totalPages = response.totalPages;
          this.nbArticle = Object.keys(this.listeArticles).length;
          this.filteredArticles = this.listeArticles;
          this.loadingArticles = false; // Set loading state to false after data is loaded
          // Mark for check
          this._changeDetectorRef.markForCheck();
        },
        error: (err) => {
          this.loadingArticles = false; // Set loading state to false in case of error
          console.log(err);
        },
      });
  }
  onPageChange(page: number) {
    this.currentPage = page;
    this.chargerArticle();
  }
  totalPagesArray(): number[] {
    return Array.from({ length: this.totalPages }, (_, index) => index);
  }
  redirectionProfil(idAuteur) {
    this.router.navigate(['/mur-utilisateur-autre', idAuteur]);
  }

  retour() {
    this.location.back();
  }
  redirectFormation() {
    if (typeof window !== 'undefined') {
      const formationUrl = 'https://formation.irbe7.com/formations/';
      window.open(formationUrl, '_blank');
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  /**
   * Filter by article
   *
   * @param change
   */
  filterByArticle(change: MatSelectChange): void {
    this.filters.articleTheme$.next(change.value);
  }
  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  recupererWatchlist() {
    let array: MarketData[] = [];
    this.dataService
      .recupererTout()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (data: MarketData[]) => {
          this.utilisateurService
            .getUtilisateurByUsername(this.loginService.getUsername())
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
              next: (user: Utilisateur[]) => {
                if (this.loginService.getIsLogged()) {
                  this.user = user[0];
                  this.user.watchlist = this.user.watchlist || [];

                  for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < this.user.watchlist.length; j++) {
                      if (
                        data[i].referentiel.stockName == this.user.watchlist[j]
                      ) {
                        array.push(data[i]);
                      }
                    }
                  }
                  this.dataSource1.data = array;
                  this._changeDetectorRef.markForCheck();
                }
              },
            });
          this._changeDetectorRef.markForCheck();
        },
      });
  }
  recupererPopulaires() {
    this.dataService
      .recupererTout()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (data: MarketData[]) => {
          this.actifs = data;
          let array = data.filter(
            (a) =>
              a.referentiel.stockName == 'TUNINDEX20' ||
              a.referentiel.stockName == 'TUNINDEX',
          );
          this.dataService
            .recupererPrincipaux()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
              next: (data: MarketData[]) => {
                let max = data[0];
                let min = data[0];
                for (let i = 1; i < data.length; i++) {
                  if (data[i].change > max.change) {
                    max = data[i];
                  } else if (data[i].change < min.change) {
                    min = data[i];
                  }
                }
                data.splice(data.indexOf(min), 1);
                data.splice(data.indexOf(max), 1);
                let max1 = data[0];
                let min1 = data[0];
                for (let i = 1; i < data.length; i++) {
                  if (data[i].change > max1.change) {
                    max1 = data[i];
                  } else if (data[i].change < min1.change) {
                    min1 = data[i];
                  }
                }
                array.push(max, max1, min, min1);
                this.dataSource.data = array;
              },
            });
        },
      });
  }

  masquerPopulaire() {
    if (this.populaires) {
      this.populaires = false;
    } else {
      this.populaires = true;
      this.watchlist = false;
    }
  }

  afficherWatchlist() {
    if (!this.loginService.getIsLogged()) {
      this.dialog.open(PopupLoginComponent);
    } else {
      if (this.watchlist) {
        this.watchlist = false;
      } else {
        this.watchlist = true;
        this.populaires = false;
      }
    }
  }
  openWatchlist() {
    if (!this.loginService.getIsLogged()) {
      this.dialog.open(PopupLoginComponent);
    } else {
      this.dialog.open(PopupWatchlistComponent);
      this.dialog.afterAllClosed.subscribe(() => {
        this.recupererWatchlist();
      });
    }
  }
}
